import css from './attribution.css'

const renderAvatar = (user) => {
    if (!user || !user.avatar_url) {
        return `<svg class="${css.logo} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18">
                <g fill="none">
                    <path fill="#0CF" d="M12 16H0v2h14v-2"/>
                    <path fill="#0F9" d="M0 2v14h2V2"/>
                    <path fill="#FFF35C" d="M6.21 0H0v2h8V0"/>
                    <path fill="#F66" d="M12 4V2h-2V0H8v6h6V4"/>
                    <path fill="#93F" d="M12 6v10h2V6"/>
                    <path fill="#000" d="M6 2h2V0m6 6h-2v2" opacity=".4"/>
                </g>
            </svg>`
    }

    return `<div class="${css.avatar}" style="background-image: url(${user.avatar_url})"></div>`
}

const renderAttribution = (user) => {
    const escapeHTML = (html) => {
        return document.createElement('div').appendChild(document.createTextNode(html)).parentNode.innerHTML
    }
    if (!user || !user.username) {
        return `<span>via GIPHY</span>`
    }
    const verifiedBadge = user.is_verified
        ? `<img src="/static/img/embeds/verified-badge.svg" class="${css.verifiedBadge}"></img>`
        : ''
    return `<span>via ${
        user.display_name ? escapeHTML(user.display_name) : user.username
    } on GIPHY ${verifiedBadge}</span>`
}

export default function (gif, giphyUrl, trackingQueryString) {
    const user = gif.user
    const url = gif && gif.url ? gif.url : giphyUrl
    return `<a class="${css.container}"
            href="${url}?${trackingQueryString}"
            onclick="trackEvent('Click', 'Attribution')">
            ${renderAvatar(user)}
            ${renderAttribution(user)}
        </a>`
}
